import { IHelpFaqModel } from "../interfaces/help_faq"; 

export const HelpFaqInitialState: IHelpFaqModel = {
  isLoading: true,
  helpfaqData: {},
  isError: false,
};
